import variables from "./theme.module.scss";

import { createMuiTheme } from "@material-ui/core/styles";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";

import "@material/react-layout-grid/dist/layout-grid.css";

const themeBreakpoints = createBreakpoints({
  values: {
    xs: parseInt(variables.breakpointXs, 10),
    sm: parseInt(variables.breakpointSm, 10),
    md: parseInt(variables.breakpointMd, 10),
    lg: parseInt(variables.breakpointLg, 10),
    xl: parseInt(variables.breakpointXl, 10),
  },
});

const theme = createMuiTheme({
  overrides: {
    MuiAppBar: {
      colorDefault: {
        backgroundColor: variables.default,
      },
    },
    MuiDialog: {
      paper: {
        "&.MuiPaper-rounded": {
          borderRadius: 16,
        },
      },
      paperWidthXs: {
        maxWidth: Math.max(themeBreakpoints.values.xs, 320),
        "&$paperScrollBody": {
          [themeBreakpoints.down(
            Math.max(themeBreakpoints.values.xs, 320) + 32 * 2
          )]: {
            maxWidth: "calc(100% - 64px)",
          },
        },
      },
      paperWidthSm: {
        maxWidth: 450,
        "&$paperScrollBody": {
          [themeBreakpoints.down(450 + 32 * 2)]: {
            maxWidth: "calc(100% - 64px)",
          },
        },
      },
    },
    MuiButton: {
      outlinedSecondary: {
        backgroundColor: variables.defaultLight,
      },
      text: {
        borderRadius: 1000,
      },
      contained: {
        borderRadius: 1000,
      },
      outlined: {
        borderRadius: 1000,
      },
    },
    // Style sheet name ⚛️
    MuiFilledInput: {
      root: {
        backgroundColor: "rgba(0, 0, 0, 0.02)",
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.05)",
        },
        "&:focused": {
          backgroundColor: "rgba(0, 0, 0, 0.05)",
        },
      },
    },
  },
  typography: {
    fontFamily: variables.baseFontFamily,
    h1: { fontFamily: variables.headerFontFamily },
    h2: { fontFamily: variables.headerFontFamily },
    h3: { fontFamily: variables.headerFontFamily },
    h4: { fontFamily: variables.headerFontFamily },
    h5: { fontFamily: variables.headerFontFamily },
    h6: {
      fontFamily: variables.headerFontFamily,
      fontSize: "1.286em",
    },
  },
  palette: {
    primary: {
      contrastText: variables.primaryContrastText,
      main: variables.primary,
      light: variables.primaryLight,
      dark: variables.primaryDark,
    },
    secondary: {
      contrastText: variables.secondaryContrastText,
      main: variables.secondary,
      light: variables.secondaryLight,
      dark: variables.secondaryDark,
    },
    error: {
      contrastText: variables.errorContrastText,
      main: variables.error,
      light: variables.errorLight,
      dark: variables.errorDark,
    },
  },
  shape: {
    borderRadius: 8,
  },
  shadows: [
    "none",
    "0 0 8px 0 rgba(0, 0, 0, 0.16)",
    "0 0 24px 0 rgba(0, 0, 0, 0.16)",
    "0px 1px 8px 0px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 3px 3px -2px rgba(0,0,0,0.12)",
    "0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)",
    "0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)",
    "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)",
    "0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)",
    "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
    "0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)",
    "0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)",
    "0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)",
    "0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)",
    "0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)",
    "0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)",
    "0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)",
    "0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)",
    "0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)",
    "0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)",
    "0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)",
    "0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)",
    "0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)",
    "0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)",
    "0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)",
    "0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)",
  ],
  breakpoints: themeBreakpoints,
});

export default theme;
